import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { analysisKeys } from '../../keys/analysis-keys';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseMeasuresProps {
  analysisId: number;
}
export function useMeasures(props: UseMeasuresProps) {
  const [poll, setPoll] = useState(false);
  const queryClient = useQueryClient();
  const query = useQuery({
    ...analysisKeys.measures(props.analysisId),
    refetchInterval: poll ? 2000 : false,
  });

  useEffect(() => {
    if (!query.data) {
      return;
    }

    // get statics values
    const statics = Object.values(query.data)
      .map((measure) => measure.static)
      .flat();
    const isStaticImageProcessing = statics.some(
      (staticMeasure) => staticMeasure?.image_processing
    );

    // get all dynamic measures
    const dynamics = Object.values(query.data)
      .map((measure) => measure.dynamic)
      .flat();

    const isDynamicImageProcessing = dynamics.some(
      (dynamic) => dynamic.image_processing
    );

    // if one of dynamic measure has image_processing == true, set poll to true
    const nextPollState = isDynamicImageProcessing || isStaticImageProcessing;
    setPoll((previous) => {
      if (previous && !nextPollState) {
        queryClient.invalidateQueries({
          queryKey: analysisKeys.measures(props.analysisId).queryKey,
        });
      }
      return nextPollState;
    });
  }, [props.analysisId, query.data, queryClient]);

  return query;
}

export default useMeasures;
